import { AssignmentType, type AssignmentEntityType } from 'domain/shared/assignment';

export const isIndividualAssignment = (assignment: AssignmentEntityType) =>
  assignment.assignmentType === AssignmentType.INDIVIDUAL_ASSIGNMENT;

export const getAssigneeName = (assignment: AssignmentEntityType): Nullable<string> | undefined =>
  isIndividualAssignment(assignment) ? assignment.employeeName : assignment.employeeGroup?.name;
